module.exports = __webpack_public_path__ + "img/shoot_00030.04cdaa36.png";